// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/es7.weak-map.from.js
// module id = 878
// module chunks = 2